// Shared visual language for the app's form modals (Create/Update patient,
// Create insurance). Mirrors the redesigned Schedule popups: an 18px card,
// Plus Jakarta Sans via `.schedule-v2-scope`, and buttons kept on Mulish via
// `.schedule-v2-mulish`.
//
// Tokens live in a .ts file rather than alongside a component so fast refresh
// keeps working (see react-refresh/only-export-components), matching the
// existing pages/Schedule/components/scheduleCalendar.tokens.ts convention.

export const MODAL_CONTENT =
  'schedule-v2-scope rounded-[18px] shadow-[0_24px_60px_rgba(16,24,40,0.28)]'

/** Uppercase section label that precedes a rule filling the rest of the row. */
export const SECTION_LABEL = 'text-[11px] font-bold tracking-[0.08em] text-[#8A929C] uppercase'
export const SECTION_RULE = 'h-px flex-1 bg-[#EEF0F2]'

export const FIELD_LABEL = 'mb-1.5 text-[13px] font-bold text-[#4A5160]'
export const FIELD_INPUT = 'h-[42px] rounded-lg border border-[#D8DBE0] text-sm'
/** Group headings inside a Mantine dropdown. */
export const GROUP_LABEL =
  'sticky top-0 overflow-hidden bg-white pt-2 !text-[12.5px] !font-bold text-[#4A5160]'

/** Spread into a Mantine input's `classNames` for the standard field look. */
export const FIELD_CLASSES = {
  root: 'w-full',
  label: FIELD_LABEL,
  input: FIELD_INPUT,
} as const

const BTN_BASE =
  'schedule-v2-mulish cursor-pointer rounded-lg px-4 py-[9px] !text-[13px] !font-bold'

export const CANCEL_BTN = `${BTN_BASE} border border-[#D8DBE0] bg-white text-[#33383F] hover:bg-[#F4F6F8]`
export const SUBMIT_BTN = `${BTN_BASE} bg-[#E5533D] text-white shadow-[0_1px_2px_rgba(203,71,31,0.3)] hover:bg-[#D4472F] disabled:cursor-not-allowed disabled:bg-[#F1F3F6] disabled:text-[#B0B6BE] disabled:shadow-none`
/** Neutral secondary action that sits alongside cancel/submit. */
export const SECONDARY_BTN = `${BTN_BASE} border border-[#D8DBE0] bg-white text-[#33383F] hover:bg-[#F4F6F8] disabled:cursor-not-allowed disabled:bg-[#F7F8FA] disabled:text-[#B0B6BE]`
/** Inline accent action (add another item, reveal more fields). */
export const GHOST_BTN =
  'schedule-v2-mulish inline-flex cursor-pointer items-center gap-1.5 rounded-md px-2 py-1 !text-[13px] !font-bold text-[#E5533D] hover:bg-[#FDECE8]'

/** Footer bar pinned under a modal's scrolling body. */
export const MODAL_FOOTER =
  'flex items-center gap-2.5 border-t border-[#EEF0F2] bg-[#F8F9FB] px-6 py-3.5'
export const FOOTER_HINT = 'mr-auto text-[12.5px] text-[#8A929C]'
